import React from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  Card,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { DOCUMENT_CENTER_ASSET_KEYS } from '../types/document-center.types';

export function HeaderComponent(props: any) {
  const navigate = useNavigate();
  const leftArrow = useStaticAsset(DOCUMENT_CENTER_ASSET_KEYS.LEFT_ARROW);
  const { title } = props;
  return (
    <Card.Flat
      css={
        {
          backgroundColor: '#EAF5FD',
          height: 'auto',
          '@desktop': { height: '152px' },
          '@laptop': { height: '152px' },
        } as GDSStyleObject
      }
    >
      <Card.Section
        css={
          {
            boxSizing: 'border-box',
            margin: '$none auto',
            width: '100%',
            maxWidth: '1150px',
            '@mobile': { padding: '10px 24px' },
            '@tablet': { paddingLeft: '24px' },
            '@mobileLandscape': { paddingLeft: '24px' },
            '@laptop': { padding: '$none 79px' },
            '@desktop': { padding: '$none 79px' },
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              display: 'flex',
              marginTop: '15px',
              marginBottom: '15px',
              flexDirection: 'row',
              '@mobile': { marginBottom: '15px' },
            } as GDSStyleObject
          }
        >
          <TextAction
            onClick={() => {
              navigate(-1);
            }}
          >
            <img
              src={leftArrow as string}
              alt="Back"
              style={{
                cursor: 'pointer',
              }}
            />
          </TextAction>

          <Box
            css={{
              display: 'inline-flex',
              height: '110px',
              paddingLeft: '22px',
              '@mobile': { height: 'auto' },
              '@mobileLandscape': { height: 'auto' },
              '@tablet': { height: 'auto' },
            }}
          >
            <HeadingText
              level="1"
              size={{
                '@initial': 'xxl',
                '@laptop': 'xxl',
                '@desktop': 'xxl',
                '@mobile': 'xxl',
                '@mobileLandscape': 'xxl',
                '@tablet': 'xxl',
              }}
              css={{
                position: 'relative',
                fontSize: '30px',
                '@mobile': {
                  paddingLeft: '$none',
                  top: '0',
                  fontSize: '24px',
                  lineHeight: '35px',
                },
                '@tablet': { paddingLeft: '$none', top: '0' },
                '@mobileLandscape': { paddingLeft: '$none', top: '0' },
                '@laptop': { paddingLeft: '$none', top: '35px' },
                '@desktop': {
                  paddingLeft: '$none',
                  top: '35px',
                } as GDSStyleObject,
              }}
            >
              {title}
            </HeadingText>
          </Box>
        </Box>
      </Card.Section>
    </Card.Flat>
  );
}
